import React from 'react';
import isBoolean from 'lodash/isBoolean';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { checkShowRow, LeadInfo } from './utils';

export const WithdrawRequestDetails: React.FC<INotificationGridItem> = ({
  date,
  notificationDetails: { data },
}) => (
  <>
    <DetailsRow label="Date" value={date} />
    <DetailsRow
      label="Client ID"
      component={<LeadInfo leadId={data.leadId} />}
    />
    <DetailsRow label="Name" value={data.leadFullName} />
    <DetailsRow label="Amount" value={`${data.amount} ${data.currency}`} />
    <DetailsRow label="Manager ID" value={data.managerId} />
    <DetailsRow label="Manager" value={data.managerName} />
    <DetailsRow label="Comment" value={data.comment} />
    {checkShowRow(data.totalDeposit) && (
      <DetailsRow label="Total Deposit" value={data.totalDeposit} />
    )}
    {checkShowRow(data.totalVolumeOfClosedDeals) && (
      <DetailsRow
        label="Total Volume Of Closed Deals"
        value={data.totalVolumeOfClosedDeals}
      />
    )}
    {checkShowRow(data.totalVolumeOfOpenDeals) && (
      <DetailsRow
        label="Total Volume Of Open Deals"
        value={data.totalVolumeOfOpenDeals}
      />
    )}
    {checkShowRow(data.numberOfDeals) && (
      <DetailsRow label="Number Of Deals" value={data.numberOfDeals} />
    )}
    {isBoolean(data.hasDealsExceedingThreshold) && (
      <DetailsRow
        label="Has Deals Exceeding Threshold"
        value={String(data.hasDealsExceedingThreshold)}
      />
    )}
  </>
);
